import React from "react";
import "./InfoCard.css";

interface Props {
  children: React.ReactNode;
  fitContentWidth?: boolean;
  firstChildIsHeader?: boolean;
}

function InfoCard(props: Props) {
  const { children, fitContentWidth, firstChildIsHeader } = props;
  const widthClass = fitContentWidth ? "info-card-section-match-width" : "";
  const paddingClass = firstChildIsHeader ? "info-card-includes-header" : "";
  const classNames = `info-card-section ${widthClass} ${paddingClass}`;

  return <section className={classNames}>{children}</section>;
}

export default InfoCard;
